import { Box, Grid } from "@mui/material";
import {
	BusinessNumberRHF,
	EmailFieldRHF,
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ExtensionNumber,
	ExtensionNumberRHF,
	LabelPosition,
	PhoneNumberRHF,
	PostCodeRHF,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
	ReducedElAccountNumberRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";

import { CountryService } from "../../../../services/common/CountryService";
import { ProvinceService } from "../../../../services/common/ProvinceService";
import { StateService } from "../../../../services/common/USAStateService";
import { useNavigateToLogout } from "../../../../common/Common";
import { useQuery } from "@tanstack/react-query";

// import { RHookFormDatePicker } from "../../../RHookFormDatePicker";




interface IAccountantInfoSetupFieldsPanel {
	// countryList: {
	// 	shortCode?: string;
	// 	label: string;
	// 	value: string;
	// 	countryType: string;
	// }[];
	// provinceDDLLoading: (value: boolean) => void;
	// formMethods: any;
	// provinceStateDDLinUpdate: any;
	// provinceStateLabelinUpdate: any;
	isAdminUser: any;
}
export const AccountantInfoSetupFieldsPanel: FC<
	IAccountantInfoSetupFieldsPanel
> = ({
	// countryList,
	// provinceDDLLoading,
	// formMethods,
	// provinceStateDDLinUpdate,
	// provinceStateLabelinUpdate,
	isAdminUser,
}) => {
		// const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
		// const [countrytype, setCountrytype] = useState("Province");
		// const [selectedCountryShortCode, setSelectedCountryShortCode] = useState("");
		// const [selectedCountry, setSelectedCountry] = useState<any>("");
		// const useGetProvinceDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.PROVINCE_DDL, () => ProvinceService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: provinceList } = useGetProvinceDDL();
		const navigateToLogout = useNavigateToLogout();

		// const useGetCountryDDL = () => {
		//   return useQuery(GET_QUERY_KEY.COUNTRY_DDL, () => CountryService.get(), {
		//     ...QUERY_OPTIONS,
		//   });
		// };
		// const { data: countryList } =
		// useGetCountryDDL();

		// const useGetStateDDL = () => {
		// 	return useQuery(GET_QUERY_KEY.USA_STATE_DDL, () => StateService.get(), {
		// 		...QUERY_OPTIONS,
		// 	});
		// };
		// const { data: stateList } = useGetStateDDL();

		// const onCountryChangeHandler = async (e: any) => {

		// 	setSelectedCountryShortCode(e.shortCode);
		// 	setSelectedCountry(e.value);
		// 	let selected = e.value;
		// 	setCountrytype(
		// 		e.countryType === "province"
		// 			? "Province"
		// 			: e.countryType === "state"
		// 			? "State"
		// 			: e.countryType
		// 	);
		// 	formMethods.setValue("province", undefined);
		// 	formMethods.setValue("state", undefined);
		// 	try {
		// 		provinceDDLLoading(true);
		// 		const responce = await CountryService.getProvinceOrStateDDL(
		// 			navigateToLogout,
		// 			selected,
		// 			e.countryType
		// 		);
		// 		setprovinceOrStateDDL(responce);
		// 	} catch {
		//
		// 	} finally {
		// 		provinceDDLLoading(false);
		// 	}
		// };

		// useEffect(() => {
		// 	if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {
		// 		
		// 		setprovinceOrStateDDL(provinceStateDDLinUpdate);
		// 		setCountrytype(
		// 			provinceStateLabelinUpdate === "province"
		// 				? "Province"
		// 				: provinceStateLabelinUpdate === "state"
		// 				? "State"
		// 				: provinceStateLabelinUpdate
		// 		);
		// 		setSelectedCountryShortCode(
		// 			provinceStateLabelinUpdate === "province"
		// 				? "CAN"
		// 				: provinceStateLabelinUpdate === "state"
		// 				? "USA"
		// 				: provinceStateLabelinUpdate
		// 		);
		// 	}
		// 	if (countryList && Array.isArray(countryList)) {
		// 		const canada = countryList.find(
		// 			(item: any) => item.label === "Canada" || "canada"
		// 		);
		// 		if (canada) {
		// 			setSelectedCountry(canada.value);
		// 			setSelectedCountryShortCode(canada.shortCode ? canada.shortCode : "");
		// 			(async () => {
		// 				try {
		// 					provinceDDLLoading(true);
		// 					const response = await CountryService.getProvinceOrStateDDL(
		// 						navigateToLogout,
		// 						canada.value,
		// 						"Province"
		// 					);
		// 					setprovinceOrStateDDL(response);
		// 					//   provinceDDLItems(response);
		// 				} catch (err) {
		// 					console.error("error", err);
		// 				} finally {
		// 					provinceDDLLoading(false);
		// 				}
		// 			})();
		// 		}
		// 	}
		// }, [provinceStateLabelinUpdate, provinceStateDDLinUpdate, countryList]);


		return (
			<div style={{ padding: "0" }}>
				<RHookFormTextFieldWithLabel
					label="Account Title"
					id="accTitle"
					testId={`account-title`}
					labelPosition={LabelPosition.Top}
					labelColumns={4}
					fieldColumns={8}
				// required
				/>
				<RHookFormTextFieldWithLabel
					label="First Name"
					id="firstName"
					testId={`first-name`}
					labelPosition={LabelPosition.Top}
					// required
					labelColumns={4}
					fieldColumns={8}
				/>
				<RHookFormTextFieldWithLabel
					label="Last Name"
					id="lastName"
					testId={`last-name`}
					labelPosition={LabelPosition.Top}
					// required
					labelColumns={4}
					fieldColumns={8}
				/>
				<RHookFormTextFieldWithLabel
					label="Initial"
					id="initial"
					testId={`initial`}
					labelPosition={LabelPosition.Top}
					// required
					labelColumns={4}
					fieldColumns={8}
				/>
				<PhoneNumberRHF
					id="phone"
					label="Phone"
					// required
					labelPosition={LabelPosition.Top}
					testId="phoneNumber"
					labelColumns={4}
					fieldColumns={8}
				/>
				<PhoneNumberRHF
					id="fax"
					label="Fax"
					// required={false}
					labelPosition={LabelPosition.Top}
					testId="faxNumber"
					labelColumns={4}
					fieldColumns={8}
				/>
				<EmailFieldRHF
					label="Email"
					id="email"
					testId={`accounatnt-email`}
					labelPosition={LabelPosition.Top}
					labelColumns={4}
					fieldColumns={8}
				// required
				/>
				{isAdminUser === 400 &&
					<>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Start Date"
							labelPosition={LabelPosition.Top}
							format="M dd, yy"
							// required
							labelColumns={4}
							fieldColumns={8}
						/>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label="End Date"
							labelPosition={LabelPosition.Top}
							format="M dd, yy"
							// required
							labelColumns={4}
							fieldColumns={8}
						/>
					</>}
			</div>
		);
	};
